/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageLevelEnum } from './messageLevelEnum';
import { MessageTypeEnum } from './messageTypeEnum';
import { MessageDeliveryError } from './messageDeliveryError';
import { NotificationResourceAction } from './notificationResourceAction';
import { MessageStateEnum } from './messageStateEnum';
import { RequestOriginEnum } from './requestOriginEnum';


export interface NotificationMessageResponse { 
    message_id?: string;
    /**
     * Service type for the message
     */
    service_type?: string;
    state?: MessageStateEnum;
    type?: MessageTypeEnum;
    level?: MessageLevelEnum;
    /**
     * Created Date Time
     */
    created_date_time?: Date;
    /**
     * Errors
     */
    errors?: Array<MessageDeliveryError>;
    /**
     * Time after which the notification should expire. This could be time in seconds, minutes, hours and days.
     */
    expires_in?: string;
    /**
     * Last Updated Date Time
     */
    last_updated_date_time?: Date;
    origin?: RequestOriginEnum;
    resource_action?: NotificationResourceAction;
    resource_id?: string;
    /**
     * Number of attempts made to deliver the message notification.
     */
    retry_attempts?: number;
    /**
     * Number of attempts failed to get the message notification delivery status.
     */
    status_check_attempts?: number;
    /**
     * User who initiated the notification request directly or indirectly.
     */
    triggered_by?: string;
}
export namespace NotificationMessageResponse {
}


